import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { cn } from '@lyearn/style';
import { Box, Typography } from '@lyearn/ui';

interface RegisteredPillProps {
  showColor?: boolean;
  useSmallLabel?: boolean;
}

const RegisteredPill = ({ showColor, useSmallLabel }: RegisteredPillProps) => {
  const { t } = useTranslation(['Events']);

  const bgColor = showColor ? 'bg-bg-tertiary' : 'bg-bg-primary';
  const textColor = showColor ? 'text-text-secondary' : 'text-text-primary';
  const variant = useSmallLabel ? 'label-03' : 'body-short-02';

  return (
    <Box className={cn('flex h-24 items-center justify-center rounded-full px-12', bgColor)}>
      <Typography color={textColor} variant={variant}>
        {t('Events:Registered')}
      </Typography>
    </Box>
  );
};

export default RegisteredPill;
